import { render, staticRenderFns } from "./InputCoordsDrag.vue?vue&type=template&id=f101c9ac&lang=pug"
import script from "./InputCoordsDrag.vue?vue&type=script&lang=js"
export * from "./InputCoordsDrag.vue?vue&type=script&lang=js"
import style0 from "./InputCoordsDrag.vue?vue&type=style&index=0&id=f101c9ac&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports